module.exports = __webpack_public_path__ + "assets/img/syj-select.77fd6efc.png";